/*eslint-disable*/
import { useGet } from "./useRequest";
export function loadAppliedApplications(page = 0, pageSize = 10) {
    const path = `/Candidates/current/ApplicationSummaries?page=${page}&size=${pageSize}`;
    return useGet(path);
}

export function loadAppliedApplicationsJobDetails(applicationId) {
    const path = `/applications/${applicationId}`;
    return useGet(path);
}

export function loadAgreementDocuments(candidateId, jobId, organisationId) {
    const path = `/applicantagreementdocument/${candidateId}/${jobId}/${organisationId}`;
    return useGet(path);
}